<template>
  <div class="feedback com-padding-top-70 com-padding-bottom-90">
    <div class="com-content-1340">
      <div class="dn-upper text-align-center">
        <div class="com-title1">用户反馈</div>
        <div class="com-line1"></div>
      </div>
      <div class="dn-form com-padding-top-50">
        <el-form
            :model="ruleForm" ref="ruleForm" label-position="top" class="el-form1">
          <el-form-item label="企业名称：" prop="company">
            <el-input v-model="ruleForm.company"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="企业邮箱：" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item label="留言内容：" prop="note" class="el-form-item-large">
            <el-input type="textarea" v-model="ruleForm.note" :rows="5"></el-input>
          </el-form-item>
          <el-form-item class="el-form-item-large">
            <el-button @click="submitForm('ruleForm')" class="el-button1">提交信息</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        company: '',
        name: '',
        phone: '',
        email: '',
        note: '',
      },
      /*
      rules: {
        company: [{required: true, message: '请输入企业名称', trigger: 'blur'}],
        name: [{required: true, message: '请输入联系人', trigger: 'blur'}],
        phone: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
        email: [{required: true, message: '请输入企业邮箱', trigger: 'blur'}],
        note: [{required: true, message: '请输入留言内容', trigger: 'blur'}],
      }
       */
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataRequestusercenter_userFeedback()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 用户反馈
    dataRequestusercenter_userFeedback() {
      let params = {
        ...this.ruleForm,
      }
      this.$api.user.usercenter_userFeedback(params).then(res => {
        if (res.code != 200) {
          this.$notify({
            message: res.message,
            type: 'error',
            duration: 2000
          })
        } else {
          this.$notify({
            message: '提交成功',
            type: 'success',
            duration: 2000
          })
          this.$refs.ruleForm.resetFields()
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.feedback {
  .dn-form {
    .el-form1 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .el-form-item {
        width: calc(100% / 2 - 1%);

        &.el-form-item-large {
          width: calc(100% / 1);
        }
      }

      ::v-deep.el-form-item__label {
        padding: 0;
      }

      .el-button1 {
        background: $color2;
        color: #ffffff;
        padding: 15px 70px;
        margin: auto;
        display: block;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .feedback {
    .dn-form {
      .el-form1 {
        .el-button1 {
          padding: 20*$mobile-conversion 70*$mobile-conversion;
        }
      }
    }
  }
}
</style>
